import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M4.54,21.51a.64.64,0,0,0-.22.49.66.66,0,0,0,.22.49l5.71,5a.67.67,0,0,0,.42.16.65.65,0,0,0,.65-.65V22.6H27V25h1.34V18.88H27v2.41H11.32V16.92a.66.66,0,0,0-.17-.44.63.63,0,0,0-.9,0Zm1.39.43L10,18.36v7.15Z' }),
  React.createElement('path', { d: 'M4.31,9.41v1.3H17.92v4.35a.66.66,0,0,0,.38.59.63.63,0,0,0,.7-.11l5.7-5a.64.64,0,0,0,.22-.49.66.66,0,0,0-.22-.49l-5.7-5a.65.65,0,0,0-1.12.49V9.41ZM19.18,6.49l4.07,3.57-4.07,3.58Z' }),
  React.createElement('rect', { x: '27.04', y: '7.01', width: '1.3', height: '6.11' })
));